'use client'

import { SelectionDictionaryParams, dictionaryQueries } from '../../api'
import { Skeleton } from '@/shared/ui/skeleton'
import { arrayValues } from '@/shared/lib/helpers/array'
import { SelectRadioGroup, SelectRadioGroupProps } from '@/shared/ui/radio-group'
import { cn } from '@/shared/lib/classnames'

export interface ComponentProps extends Omit<SelectRadioGroupProps, 'defaultValues' | 'options'> {
  dictionary: SelectionDictionaryParams
  skeletonCount?: number
  isLoading?: boolean
}

export default function Component(props: ComponentProps) {
  const { data, isLoading } = dictionaryQueries.useGet(props.dictionary)
  if (isLoading || props?.isLoading) {
    return arrayValues(props.skeletonCount || 3).map((v, i) => <Skeleton key={i} className="w-full h-10" />)
  }

  return (
    <SelectRadioGroup
      idFieldName="id"
      valueFieldName="id"
      labelFieldName="name"
      {...props}
      options={data || []}
      className={cn('border p-2 rounded-md', props.className)}
    />
  )
}
